"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCache = void 0;
var createCache = function (load, keyToString) {
    var cache = {};
    var loaded = {};
    return {
        isLoaded: function (key) { return keyToString(key) in loaded; },
        get: function (key) {
            var data = loaded[keyToString(key)] || null;
            if (!data) {
                throw new Error("No cached data for ".concat(key));
            }
            return data;
        },
        set: function (key, data) {
            loaded[keyToString(key)] = data;
        },
        load: function (key) {
            var keyString = keyToString(key);
            var cachedPromise = cache[keyString];
            if (cachedPromise) {
                return cachedPromise;
            }
            var dataPromise = load(key);
            dataPromise
                .then(function (data) {
                loaded[keyString] = data;
            })
                .catch(function () { });
            cache[keyString] = dataPromise;
            return dataPromise;
        },
    };
};
exports.createCache = createCache;
